import { matchPath, type PathMatch } from 'react-router-dom';

import { store } from 'src/app/store';

import { campaignEndpoints } from '../campaigns.slice';
import { removeNotApplicableCampaign, setActiveCampaign, setNotApplicableCampaign } from './campaign-storage';

export const checkMatch = (paths: string[], pathname: string) => {
  let match: PathMatch | null = null;
  for (const path of paths) {
    match = matchPath(path, pathname);
    if (match) {
      break;
    }
  }

  return {
    doesMatch: !!match,
    isWideMatch: !!match?.params['*'],
  };
};

export const checkIfPathMatches = (pathsToExclude: string[], pathsToInclude: string[], pathname: string) => {
  const negativeMatch = checkMatch(pathsToExclude, pathname);
  const positiveMatch = checkMatch(pathsToInclude, pathname);

  if (!pathsToInclude.length && !negativeMatch.doesMatch) {
    return true;
  }

  if (!negativeMatch.doesMatch && !positiveMatch.doesMatch) {
    return false;
  }

  let matches = false;
  if (negativeMatch.doesMatch && positiveMatch.doesMatch) {
    matches = negativeMatch.isWideMatch || !positiveMatch.isWideMatch;
  } else if (positiveMatch.doesMatch) {
    matches = true;
  }

  return matches;
};

export const storeActiveCampaignSession = async (name: string) => {
  const query = store.dispatch(campaignEndpoints.getCampaigns.initiate());

  try {
    const { data } = await query.unwrap();
    const campaign = data?.find((c) => c.name === name);

    if (!campaign) setNotApplicableCampaign(campaign);

    if (!campaign || !campaign.sessionExpiration) {
      return;
    }

    removeNotApplicableCampaign();

    setActiveCampaign(campaign);
  } finally {
    query.unsubscribe();
  }

  return null;
};
